import React from 'react'
import Bookings from './Bookings'
import Example from './Example'

const DefaultContent = () => {
  return (
    <Bookings />
  )
}

export default DefaultContent
